function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.04326 19.5274C6.95552 19.5274 6.95565 16.6569 8.04326 16.6569H15.067C15.8738 16.6569 16.1767 16.0384 16.3637 15.3396L19.1969 5.84616C19.4768 4.80009 21.6633 5.21764 21.38 6.28006L18.5372 17.0251C18.156 18.4738 16.6723 19.5274 15.1021 19.5274H8.04326V19.5274ZM13.1229 13.5559L12.9959 14.0299H8.50249C7.85077 14.0299 7.29242 13.6283 7.06162 13.0589H5.99387C5.3315 13.0589 4.78461 13.5535 4.7023 14.1935L3.03368 21.6645C2.68043 23.024 5.21453 23.5697 5.56722 22.2244L6.90686 16.177C6.92261 16.0467 7.00012 15.9915 7.11931 15.9876H13.5813C14.6248 15.9876 15.5224 15.4562 15.8236 14.4168L17.391 9.00097C17.7235 7.85381 17.0629 6.65412 15.9156 6.32154C14.9188 6.03251 13.6399 6.35866 13.3184 7.48235L12.2649 11.1619C12.2316 11.3155 12.1319 11.3868 11.9759 11.3905H8.50249C7.90317 11.3905 7.4171 11.8765 7.4171 12.4757C7.4171 13.0751 7.9032 13.561 8.50249 13.561L13.1229 13.5559ZM15.9267 1C14.6158 1 13.553 2.063 13.553 3.37392C13.553 4.68498 14.6158 5.74774 15.9267 5.74774C17.2377 5.74774 18.3006 4.68498 18.3006 3.37392C18.3006 2.063 17.2377 1 15.9267 1ZM7.59243 1.29068C5.14976 1.29068 3.16956 3.27085 3.16956 5.71355C3.16956 8.15612 5.14973 10.1364 7.59243 10.1364C10.0351 10.1364 12.0153 8.15612 12.0153 5.71355C12.0153 3.27085 10.0351 1.29068 7.59243 1.29068Z",
  fill: "current"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/airbug.848b5d89.svg";
export { SvgComponent as ReactComponent };